module.exports = __webpack_public_path__ + "img/index-banner-2.6c82c35e.jpg";